import { toast } from "react-toastify";
import axios from '../service/axios';


export const exportLayout = async (item, format = 'stack360') => {
    try {

        if (format === 'json') {
            // Legacy JSON export
            const { data } = await axios.get(`warehouse-layout/${item?.id}/export/?format=json`);
            const response = JSON.stringify(data?.data);
            const blob = new Blob([response], { type: "application/json" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `${item?.name}.json`;
            link.click();
            toast.success("Layout exported as JSON");
        } else {
            // Default: Compressed .stack360 export
            const response = await axios.get(`warehouse-layout/${item?.id}/export/`, {
                responseType: 'blob' // Important: get binary data
            });

            const blob = new Blob([response.data], { type: 'application/octet-stream' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;

            // Get filename from response headers or generate one
            const filename = response.headers['content-disposition']?.match(/filename="(.+)"/)?.[1]
                || `${item?.name.replace(/[^a-zA-Z0-9]/g, '_')}.stack360`;
            link.download = filename;
            link.click();

            // Show compression stats if available
            const originalSize = response.headers['x-original-size'];
            const compressedSize = response.headers['x-compressed-size'];
            if (originalSize && compressedSize) {
                const compressionRatio = ((1 - compressedSize / originalSize) * 100).toFixed(1);
                toast.success(`Layout exported as compressed file (${compressionRatio}% smaller)`);
            } else {
                toast.success("Layout exported as compressed file");
            }
        }
    } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || 'Export failed';
        toast.error(errorMessage);
        console.log("error", error);
    } finally {
    }
}; 